import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';

const IconAnomalySignal = ({ width = 16, height = 1, viewBox = '0 0 16 1', color = colors.orangePeel }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M19 4L0.999999 4' stroke={color} strokeLinecap='round' />
        <path d='M37 3.5C37.2761 3.5 37.5 3.72386 37.5 4C37.5 4.27614 37.2761 4.5 37 4.5L37 4L37 3.5ZM16.1132 4L19 1.11325L21.8868 4L19 6.88675L16.1132 4ZM37 4L37 4.5L19 4.5L19 4L19 3.5L37 3.5L37 4Z' fill={color} />
    </svg>;
};

IconAnomalySignal.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconAnomalySignal;
